import * as api from '../api/dataEntry';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_DATA_ENTRIES = createRequestTypes(
  'DATA_ENTRY/FETCH_DATA_ENTRIES',
);

export const fetchDataEntries = makeApiActionCreatorV3(
  api.fetchDataEntries,
  FETCH_DATA_ENTRIES[START],
  FETCH_DATA_ENTRIES[SUCCESS],
  FETCH_DATA_ENTRIES[ERROR],
);

export const CREATE_DATA_ENTRY = createRequestTypes(
  'DATA_ENTRY/CREATE_DATA_ENTRY',
);

export const createDataEntry = makeApiActionCreatorV3(
  api.createDataEntry,
  CREATE_DATA_ENTRY[START],
  CREATE_DATA_ENTRY[SUCCESS],
  CREATE_DATA_ENTRY[ERROR],
);

export const FETCH_DATA_ENTRY = createRequestTypes(
  'DATA_ENTRY/FETCH_DATA_ENTRY',
);

export const fetchDataEntry = makeApiActionCreatorV3(
  api.fetchDataEntry,
  FETCH_DATA_ENTRY[START],
  FETCH_DATA_ENTRY[SUCCESS],
  FETCH_DATA_ENTRY[ERROR],
);

export const UPDATE_DATA_ENTRY = createRequestTypes(
  'DATA_ENTRY/UPDATE_DATA_ENTRY',
);

export const updateDataEntry = makeApiActionCreatorV3(
  api.updateDataEntry,
  UPDATE_DATA_ENTRY[START],
  UPDATE_DATA_ENTRY[SUCCESS],
  UPDATE_DATA_ENTRY[ERROR],
);

export const UPDATE_DATA_ENTRY_IMPROVEMENT_VALUES = createRequestTypes(
  'DATA_ENTRY/UPDATE_DATA_ENTRY_IMPROVEMENT_VALUES',
);

export const updateDataEntryImprovementValues = makeApiActionCreatorV3(
  api.updateDataEntryImprovementValues,
  UPDATE_DATA_ENTRY_IMPROVEMENT_VALUES[START],
  UPDATE_DATA_ENTRY_IMPROVEMENT_VALUES[SUCCESS],
  UPDATE_DATA_ENTRY_IMPROVEMENT_VALUES[ERROR],
);

export const FETCH_DATA_ENTRY_PROP_USES = createRequestTypes(
  'DATA_ENTRY/FETCH_DATA_ENTRY_PROP_USES',
);

export const fetchDataEntryPropUses = makeApiActionCreatorV3(
  api.fetchDataEntryPropUses,
  FETCH_DATA_ENTRY_PROP_USES[START],
  FETCH_DATA_ENTRY_PROP_USES[SUCCESS],
  FETCH_DATA_ENTRY_PROP_USES[ERROR],
);

export const UPDATE_DATA_ENTRY_PROP_USES = createRequestTypes(
  'DATA_ENTRY/UPDATE_DATA_ENTRY_PROP_USES',
);

export const updateDataEntryPropUses = makeApiActionCreatorV3(
  api.updateDataEntryPropUses,
  UPDATE_DATA_ENTRY_PROP_USES[START],
  UPDATE_DATA_ENTRY_PROP_USES[SUCCESS],
  UPDATE_DATA_ENTRY_PROP_USES[ERROR],
);

export const FETCH_DATA_ENTRY_OPTIONS = createRequestTypes(
  'DATA_ENTRY/FETCH_DATA_ENTRY_OPTIONS',
);

export const fetchDataEntryOptions = makeApiActionCreatorV3(
  api.fetchDataEntryOptions,
  FETCH_DATA_ENTRY_OPTIONS[START],
  FETCH_DATA_ENTRY_OPTIONS[SUCCESS],
  FETCH_DATA_ENTRY_OPTIONS[ERROR],
);

export const UPDATE_DATA_ENTRY_OPTION = createRequestTypes(
  'DATA_ENTRY/UPDATE_DATA_ENTRY_OPTION',
);

export const updateDataEntryOption = makeApiActionCreatorV3(
  api.updateDataEntryOption,
  UPDATE_DATA_ENTRY_OPTION[START],
  UPDATE_DATA_ENTRY_OPTION[SUCCESS],
  UPDATE_DATA_ENTRY_OPTION[ERROR],
);
